export enum CustomerQuoteColId {
  ALTERNATE_VERSION_ENABLED = 'alternateVersionEnabled',
  ARCHIVED = 'archived',
  BILL_TO_ACCOUNT_NUMBER = 'billToAccountNumber',
  CLOSE_CONFIDENCE = 'closeConfidence',
  CREATED_AT = 'createdAt',
  CUSTOMER_CONTACT_GROUP_NAME = 'customerContactGroupName',
  CUSTOMER_CONTACT_GROUPING = 'customerContactGrouping',
  CUSTOMER_CONTACT_NAME = 'customerContactName',
  ESTIMATED_CLOSE_DATE = 'estimatedCloseDate',
  EXTERNAL_CUSTOMER_NUMBER = 'externalCustomerNumber',
  EXTERNAL_ORDER_NUMBER = 'externalOrderNumber',
  EXTERNAL_PENDING_ORDER_NUMBER = 'externalPendingOrderNumber',
  EXTERNAL_STATUS = 'externalStatus',
  ID = 'id',
  JOB_NAME = 'jobName',
  LOCATION_NAME = 'locationName',
  OWNER_USER_NAME = 'ownerUserName',
  PARENT_ID = 'parentId',
  PURCHASE_ORDER_NUMBER = 'purchaseOrderNumber',
  STATUS = 'status',
  TOTAL_PRICE = 'totalPrice',
  UPDATED_AT = 'updatedAt',
  VALID_UNTIL = 'validUntil',
  VENDOR_CORPORATE_USER_NAME = 'vendorCorporateUserName',
  VENDOR_PROJECT_NAME = 'vendorProjectName',
  VERTICAL_MARKET_NAME = 'verticalMarketName',
}
